export const createInviteMessage = (name, givePremiumTrialDays) => `${name} has invited you to Emma: You get ${givePremiumTrialDays} days of premium for free! Download the app to start saving 💰`;
